export function RemovePicFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2 7a3 3 0 013-3h3.93a3 3 0 012.496 1.336l.812 1.219A1 1 0 0013.07 7H19a3 3 0 013 3v3.682A6 6 0 1111.803 20H5a3 3 0 01-3-3V7zm8.516 8.42l1.336-1.503A5.961 5.961 0 0011.083 16H6l2.116-2.54a.5.5 0 01.768 0l1.632 1.96zM10 10a2 2 0 11-4 0 2 2 0 014 0zm4 6a1 1 0 100 2h6a1 1 0 100-2h-6z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
